import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div
      style={{
        height: "100vh",
        background: "#0B0B0B",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1 style={{ fontSize: "6rem" }}>404</h1>

      <p>Page Not Found</p>

      <Link
        to="/"
        style={{
          marginTop: "20px",
          padding: "12px 24px",
          background: "#C8A96B",
          color: "#000",
          textDecoration: "none",
          borderRadius: "5px",
        }}
      >
        Back Home
      </Link>
    </div>
  );
};

export default NotFound;